import { useEffect, useRef, useCallback } from 'react';

const IDLE_TIMEOUT_MS = 15 * 60 * 1000;
const WARNING_BEFORE_MS = 60 * 1000;

export default function useIdleTimer(onWarning, onExpire, isAuthenticated) {
  const lastActivity = useRef(Date.now());
  const warningShown = useRef(false);

  const resetTimer = useCallback(() => {
    lastActivity.current = Date.now();
    warningShown.current = false;
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;
    const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'wheel'];
    const handler = () => { lastActivity.current = Date.now(); };
    events.forEach(e => window.addEventListener(e, handler, { passive: true }));

    const tick = setInterval(() => {
      const elapsed = Date.now() - lastActivity.current;
      const remaining = IDLE_TIMEOUT_MS - elapsed;
      if (remaining <= 0) {
        onExpire();
      } else if (remaining <= WARNING_BEFORE_MS && !warningShown.current) {
        warningShown.current = true;
        onWarning(Math.ceil(remaining / 1000));
      }
    }, 1000);

    return () => {
      events.forEach(e => window.removeEventListener(e, handler));
      clearInterval(tick);
    };
  }, [isAuthenticated, onWarning, onExpire]);

  return { resetTimer };
}
